<template>
  <div id="flights">
    <div>
      <div v-for="(leg, index) in flights?.route" :key="index" class="form-section">
        <h4>{{ flightTitle(index) }}</h4>
        <Flight v-if="leg.ideal?.legs?.length" :key="index" :flight="leg.ideal" :flight-way="'summary'" :is-lander="isLander" :program="props.program" :is-edit="isEdit" :flight-cabin="flights.cabin" :is-summary="true" @edit="emit('edit', index)" />
      </div>
    </div>
  </div>
</template>

<script setup>
import Flight from "./TripNewBookFlightsItem.vue";

const emit = defineEmits(["edit"]);
const props = defineProps(["isEdit", "flights", "program", "isLander"]);

const flightTitle = index => {
  if ((props.flights?.way != "oneway" && props.flights?.way != "roundtrip") || index >= 2) {
    return "Flight " + (index + 1);
  }
  return index == 0 ? "Outbound Flight" : "Inbound Flight";
};
</script>

